import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { API_URL } from "../consts";
import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import IconButton from "@mui/material/IconButton";
import { visuallyHidden } from "@mui/utils";
import EditIcon from "@mui/icons-material/Edit";
import { Button, Dialog, TextField, useMediaQuery } from "@mui/material";
import { Order, stableSort, getComparator } from "../ui/Tables";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useTheme } from "@mui/material/styles";
import { TariffeDefinizione } from "./TariffeDefinizione";
import { useEffect, useState } from "react";
import { oraPrenotaStore } from "../oraPrenotaStore";
import { TariffeCosto } from "../tariffeCosto/TariffeCosto";
import { TariffeData } from "./TariffeData";
import { uiStore } from "../uiStore";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

interface HeadCell {
  disablePadding: boolean;
  id: keyof TariffeData;
  label: string;
  numeric: boolean;
  key?: string;
  sortable: boolean;
  filter: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "id",
    numeric: true,
    disablePadding: false,
    label: "",
    sortable: false,
    filter: false,
  },
  {
    id: "codice",
    numeric: false,
    disablePadding: false,
    label: "Codice",
    sortable: true,
    filter: true,
  },
  {
    id: "nome",
    numeric: false,
    disablePadding: false,
    label: "Nome",
    sortable: true,
    filter: true,
  },
  {
    id: "coloriId",
    numeric: false,
    disablePadding: false,
    label: "Colore",
    sortable: true,
    filter: false,
  },
  {
    id: "luciStatus",
    numeric: false,
    disablePadding: false,
    label: "Luci",
    sortable: true,
    filter: false,
  },
  {
    id: "riscaldamentoStatus",
    numeric: false,
    disablePadding: false,
    label: "Riscaldamento",
    sortable: true,
    filter: false,
  },
  {
    id: "id",
    key: "id2",
    numeric: true,
    disablePadding: false,
    label: "",
    sortable: false,
    filter: false,
  },
];

interface EnhancedTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof TariffeData) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
  onFilter: (event: any, property: keyof TariffeData, filter: string | number) => void;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort, onFilter } = props;
  const createSortHandler = (property: keyof TariffeData) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };
  const createFilterHandler = (property: keyof TariffeData) => (event: any) => {
    onFilter(event, property, event.target.value);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.key ? headCell.key : headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sortable && (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.key ? headCell.key : headCell.id}>
            {headCell.filter && (
              <TextField label="" variant="standard" onChange={createFilterHandler(headCell.id)} />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function Row(props: {
  row: TariffeData;
  edit: (id: number) => void;
  editTariffa: (data: TariffeData) => void;
}) {
  const { row, edit, editTariffa } = props;

  return (
    <>
      <TableRow hover tabIndex={-1}>
        <TableCell sx={{ whiteSpace: "nowrap" }}>
          <IconButton aria-label="edit" onClick={() => edit(row.id)} sx={{ p: 0 }}>
            <EditIcon />
          </IconButton>
        </TableCell>
        <TableCell>{row.codice}</TableCell>
        <TableCell>{row.nome}</TableCell>
        <TableCell sx={{ bgcolor: row.colore.esadecimale }}>{row.colore.nome}</TableCell>
        <TableCell>{row.luciStatus ? "Si" : "No"}</TableCell>
        <TableCell>{row.riscaldamentoStatus ? "Si" : "No"}</TableCell>
        <TableCell sx={{ whiteSpace: "nowrap" }}>
          <IconButton onClick={() => editTariffa(row)} sx={{ p: 0 }}>
            <ShoppingCartIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
}

export function TariffeDefinizioni() {
  const { isLoading, data } = useQuery<unknown, AxiosError, { definizioni: TariffeData[] }>(
    ["tariffe-definizioni/findAll"],
    () => axios.get(API_URL + "tariffe-definizioni/findAll").then((res) => res.data)
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [open2, setOpen2] = useState(false);
  const handleClickOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  const [open3, setOpen3] = useState(false);
  const handleClickOpen3 = () => {
    setOpen3(true);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };

  const [id, setId] = useState(0);
  const [tariffeData, setTariffeData] = useState<TariffeData>();

  const rows = data?.definizioni ?? [];

  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<keyof TariffeData>("id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filters, setFilters] = useState({});
  const dense = oraPrenotaStore((state) => state.tabelleCompatte);

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof TariffeData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleFilterRequest = (
    event: React.MouseEvent<unknown>,
    property: keyof TariffeData,
    filter: string | number
  ) => {
    setFilters({
      ...filters,
      [property]: filter,
    });
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const edit = (id: number) => {
    setId(id);
    handleClickOpen2();
  };
  const editTariffa = (data: TariffeData) => {
    setTariffeData(data);
    handleClickOpen3();
  };

  const setTitle = uiStore((state) => state.setTitle);
  useEffect(() => {
    setTitle("Gestione Tariffe");
  }, [setTitle]);

  if (isLoading) return <></>;

  return (
    <Box sx={{ width: "100%" }}>
      <Button
        color="secondary"
        onClick={handleClickOpen}
        sx={{ mb: 2 }}
        startIcon={<AddCircleOutlineIcon />}
      >
        Aggiungi Tariffa
      </Button>

      <TableContainer>
        <Table size={dense ? "small" : "medium"}>
          <EnhancedTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
            onFilter={handleFilterRequest}
          />
          <TableBody classes={{ root: "table-body" }}>
            {stableSort(rows, getComparator(order, orderBy), filters)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return <Row row={row} key={row.id} edit={edit} editTariffa={editTariffa} />;
              })}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: (dense ? 33 : 53) * emptyRows,
                }}
              ></TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <Dialog open={open} onClose={handleClose} fullScreen={fullScreen}>
        <TariffeDefinizione closeDialog={handleClose} />
      </Dialog>
      <Dialog open={open2} onClose={handleClose2} fullScreen={fullScreen}>
        <TariffeDefinizione id={id} closeDialog={handleClose2} />
      </Dialog>
      <Dialog open={open3} onClose={handleClose3} fullScreen={fullScreen}>
        {tariffeData && <TariffeCosto data={tariffeData} closeDialog={handleClose3} />}
      </Dialog>
    </Box>
  );
}
